import React, { useEffect, useState, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ImagesViewList = ({ attachments, setAttachments, createEmptyRow }) => {

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const handleView = (file) => {
        if (!file) return;
        setPreviewImage(file);
        setPreviewModal(true);
    };

    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>File Name</th>
                        <th>Remarks</th>
                        <th>Upload</th>
                        <th>View</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.originalFileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled
                                    value={row.remarks}
                                    className="form-control"
                                />
                            </td>

                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    disabled
                                />
                                <button
                                    className="mainbtn"
                                    disabled
                                >
                                    Upload
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnRed"
                                    onClick={() => handleView(row.fullUrl)}
                                >
                                    View
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    disabled
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{ width: "100%" }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ImagesViewList